import { Directive } from '@angular/core';

@Directive({
  selector: '[appToastMessageIcon]',
})
export class ToastMessageIconDirective {}
